var _circle, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 38.5,
    r: 38.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.5158,
    y: 24.8171,
    width: 2.25483,
    height: 34.8804,
    rx: 1.12741,
    transform: "rotate(29.9682 46.5158 24.8171)",
    fill: "black",
    stroke: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0778 25.4375C48.7165 25.4375 56.5095 31.8633 56.5095 39.6562C56.5095 47.5176 48.7165 53.875 39.0778 53.875C36.4118 53.875 33.9509 53.3965 31.695 52.5762C30.0544 53.9434 26.6364 56.0625 22.1247 56.0625C21.8513 56.0625 21.7146 55.9941 21.5778 55.7891C21.5095 55.584 21.5778 55.3105 21.7146 55.1738C21.7146 55.1055 24.5856 52.0977 25.406 48.6113C23.0134 46.2188 21.5778 43.0742 21.5778 39.6562C21.5778 31.8633 29.3708 25.4375 39.0778 25.4375ZM39.0778 52.7812C48.1013 52.7812 55.4841 46.9023 55.4841 39.6562C55.4841 32.4785 48.1013 26.5312 39.0778 26.5312C29.986 26.5312 22.6716 32.4785 22.6716 39.6562C22.6716 42.6641 23.9021 45.5352 26.2263 47.8594L26.6364 48.2695L26.4997 48.8848C25.8845 51.4141 24.3122 53.6699 23.2868 54.9688C26.9099 54.627 29.6442 52.8496 31.0114 51.7559L31.4899 51.3457L32.1052 51.5508C34.2927 52.3711 36.6169 52.7812 39.0778 52.7812Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNote);
export default __webpack_public_path__ + "static/media/no-note.46b63d869734fd864eabcb6b5ea0ff7e.svg";
export { ForwardRef as ReactComponent };